<i18n>
{
  "fr": {
      "submit": "Enregistrer",
      "submitForValidation": "Enregistrer pour validation",
      "cancel": "Retour",
      "infoEquipement": "Ce(s) équipement(s) est(sont)",
      "title": "Création du formulaire Conformité",
      "titleForm": "Conformité - Dossier N°{folderNumber}",
      "processing": "Traitement en cours..."
  }
}
</i18n>

<template>
  <div>
    <InfoBar :title="this.$i18n.t('title')" />
    <b-card class="mg-t-10 pd-0">
      <div :class="{noActive : isProcessing }" class="conformite">
        <div :class="{ 'no-data-message': isProcessing }" id="processing-message" class="message">
          <div class="content">
            <h4 class="align-center">
              <slot name="Loading">{{ this.$i18n.t('processing') }}</slot>
            </h4>
          </div>
        </div>
        <div :class="{ 'no-data': isProcessing }">
          <form id="conformite" name="dynamic-validation" @submit.prevent="">
            <ConformiteFields name="conformiteFields" :conformiteForm="conformiteForm"
              :title="this.$i18n.t('titleForm', { folderNumber: property.folderNumber})" />
            <b-row>
              <b-col cols="12" class="submit-form">
                <b-link class="btn btn-gray mg-r-10" @click="onCancel">{{ $t('cancel') }}</b-link>

                <b-button type="submit" class="btn btn-cta s-btn" v-on:click="handleSubmit('save')">
                  <b-spinner v-if="isProcessing" />
                  {{ $t('submit') }}
                </b-button>

                <b-button :disabled="dateOfVisitValidation" type="submit" class="btn btn-cta s-btn ml-3 disp-msg"
                  v-on:click="handleSubmit('saveForValidation')">
                  <b-spinner v-if="isProcessing" />
                  {{ $t('submitForValidation') }}
                </b-button>
                <span v-if="dateOfVisitValidation" class="ndisp red">Date de visite non saisie</span>
              </b-col>
            </b-row>
          </form>
        </div>
      </div>
    </b-card>
    <ajax-intercept @start="ajaxStart" @finish="ajaxFinish"></ajax-intercept>
  </div>
</template>

<script>
import ConformiteFields from '../fields/ConformiteFields.vue';
import InfoBar from '../properties/InfoBar';
import { TYPE_CONFORMITE } from '../../constants/params';
import { mapActions, mapState } from 'vuex';
import ajaxIntercept from 'vue-ajax-intercept';

export default {
  name: 'ConformiteForm',
  components: {
    ConformiteFields,
    InfoBar,
    ajaxIntercept,
  },
  data: () => ({
    isProcessing: false,
    submitType: 'save',
    ajaxInterceptorCounter: 0,
  }),
  created() {
    this.setTypeForm();
    this.initConformiteForm();
    this.initNotif();
  },
  computed: {
    ...mapState({
      property: state => state.refProperties.property,
      conformiteForm: state => state.conformite.conformiteForm,
    }),
    dateOfVisitValidation() {
      if (this.conformiteForm.dateOfVisit === undefined || this.conformiteForm.dateOfVisit === null) {
        return true;
      }
      return false;
    },
  },
  methods: {
    ...mapActions(['initConformiteForm', 'initNotif']),
    handleSubmit(submitType) {
      if (submitType === 'saveForValidation') {
        if (!confirm('Vous ne pourrez plus modifier le formulaire après cette action !')) {
          return;
        }
        this.conformiteForm.forceStatusWaitingForValidation = true;
      } else {
        this.conformiteForm.forceStatusWaitingForValidation = false;
      }
      this.isProcessing = true;
      this.setFilesInForm();
      this.$store.dispatch('handleSubmit');
    },
    setFilesInForm() {
      var parentComponent = this.$children.find(x => x.$attrs.name === 'conformiteFields');
      var dropzoneComponent = parentComponent.$children.find(x => x.$attrs.name === 'filesDropzone');
      this.$store.dispatch('setFilesInForm', { component: dropzoneComponent, form: this.conformiteForm });
    },
    setTypeForm() {
      this.$store.commit('setTypeForm', TYPE_CONFORMITE);
    },
    onCancel() {
      this.initConformiteForm();
      this.initNotif();
      this.$router.push({ name: `property_detail`, params: { propertyId: this.property.id } });
    },
    ajaxStart() {
      this.ajaxInterceptorCounter++;
      this.isProcessing = true;
    },
    ajaxFinish() {
      this.ajaxInterceptorCounter--;
      if (this.ajaxInterceptorCounter <= 0) {
        this.isProcessing = false;
      }
    },
  },
};
</script>
